import * as $ from 'jquery';
import 'jqueryui';

import {
  saveDesignHTMLService,
  authorizeStripo,
  setMissingLinkErrorOnDesign,
  enablePreviewAction,
  disablePreviewAction,
  changeTemplateLoading,
  designSkeletonLoad,
  designSkeletonLoadSuccess,
  setSaveLoading,
} from './../action';
import { SECTION_ID } from '../../../constants/index';
import { SAVING_DESIGN } from 'constants/actionTypes';
import store from 'store';
import { disablePublishButton, enablePublishButton } from 'modules/Campaigns/Emails/actions';
import { getQueryCampaignId, getQueryEmailId } from 'modules/EmailBrowser/utils';
import { ReactComponent as WarningIcon } from '../../../assets/img/icons/warningWhiteIcon.svg';
import ErrorIcon from '../../../assets/img/icons/error.svg';
import { setAIEmailDesign } from 'modules/Campaigns/CampaignAssets/actions';

var apiRequestData = { emailId: 112233, userId: 332211 };
window.right_article_array = [];
window.article_descriptions = [];
window.page_HTML = '';
var deleted_articles = {};
var hero_article_structure = '';
var small_articles_structure = '';

var unsubLink = '*|unSubscribeLink|*';
var _template_style_id = 0;
var _design;

function templateLoad(design = null, flag = false, callbackFunc = null, skipUpdateHtml = false, enableSaveAsButton) {
  stripo_onTemplateLoaded(design, flag, callbackFunc, skipUpdateHtml, enableSaveAsButton);
}

var notifications = {
  autoCloseTimeout: 8000,
  container: '.notification-zone',
  error: function (text, id, params) {
    this.showNotification(
      this.getErrorNotification.bind(this),
      'Sorry, we do not support the JFIF image format. Please convert your image to a supported format such as PNG or JPEG before uploading. Please contact support@xiqinc.com to get further help.',
      id,
      params,
    );
  },
  warn: function (text, id, params) {
    this.showNotification(this.getWarningNotification.bind(this), text, id, params);
  },
  info: function (text, id, params) {
    this.showNotification(this.getInfoNotification.bind(this), text, id, params);
  },
  success: function (text, id, params) {
    this.showNotification(this.getSuccessNotification.bind(this), text, id, params);
  },
  loader: function (text, id, params) {
    this.showNotification(this.getLoaderNotification.bind(this), text, id, params);
  },
  hide: function (id) {
    var toast = $('#' + id, this.container);
    toast.effect('fade', 600, function () {
      toast.remove();
    });
  },
  showNotification: function (notificationGetter, text, id, params) {
    params = Object.assign({ autoClose: true, closeable: true }, params || {});
    // message.warning({
    //   text,
    //   style: {
    //     marginTop: '13vh',
    //   },
    //   rtl: true,
    //   className: 'warning-message-design',
    //   icon: <WarningIcon style={{ marginRight: '5px' }} />
    // })
    if (!id || !$('#' + id).length) {
      var toast = notificationGetter(text, id, !params.closeable);
      $(this.container).append(toast);
      toast.effect('slide', { direction: 'up' }, 300);
      if (params.autoClose) {
        setTimeout(function () {
          toast.effect('fade', 8000, function () {
            toast.remove();
          });
        }, this.autoCloseTimeout);
      }
    }
  },
  getErrorNotification: function (text, id, nonclosable) {
    return this.getNotificationTemplate('alert-danger', text, id, nonclosable);
  },
  getWarningNotification: function (text, id, nonclosable) {
    return this.getNotificationTemplate('alert-warning', text, id, nonclosable);
  },
  getInfoNotification: function (text, id, nonclosable) {
    return this.getNotificationTemplate('alert-info', text, id, nonclosable);
  },
  getSuccessNotification: function (text, id, nonclosable) {
    return this.getNotificationTemplate('alert-success', text, id, nonclosable);
  },
  getLoaderNotification: function (text, id) {
    var notification = $(
      '<div class="alert alert-info" role="alert"><div style="width:auto; margin-right: 15px; float: left !important;"><div style="width:20px;height:20px;border-radius:50%;box-shadow:1px 1px 0px #31708f; animation:cssload-spin 690ms infinite linear"></div></div>' +
        text +
        '</div>',
    );
    id && notification.attr('id', id);
    return notification;
  },
  getNotificationTemplate: function (classes, text, id, nonclosable) {
    var notification = $(
      '<div class="alert alert-dismissible ' +
        classes +
        (nonclosable ? ' nonclosable' : '') +
        '" role="alert">' +
        (nonclosable
          ? ''
          : '<button style="display:none;" type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>') +
        (classes.includes('alert-danger') ? `<img src=${ErrorIcon} style="margin-right: 8px; height:21px;" />` : '') +
        text +
        '</div>',
    );
    id && notification.attr('id', id);
    return notification;
  },
};

async function load_stripo(
  design = null,
  html = '',
  css = '',
  apiRequestData = { emailId: 112233, userId: 332211 },
  callbackFunc = null,
  enablePreview = null,
  skipUpdateHtml = false,
  enableSaveAsButton,
) {
  let stripoScriptSrc = document.getElementById('stripoScript');
  // console.log('inside load_stripo')
  // console.log('inside load_stripo', stripoScriptSrc)
  // console.log('inside load_stripo', window.Stripo)

  if (stripoScriptSrc === undefined || stripoScriptSrc === null) {
    const script = document.createElement('script');
    script.id = 'stripoScript';
    script.type = 'text/javascript';
    script.src = process.env.PUBLIC_URL + '/js/stripo/stripo.js';
    document.body.appendChild(script);
    script.onload = function () {
      stripoInjection(design, html, css, apiRequestData, callbackFunc, enablePreview, skipUpdateHtml, enableSaveAsButton, false);
    };
  } else if (window.Stripo) {
    // console.log('inside window.Stripo', window.StripoApi)
    // window.StripoApi.stop();
    stripoInjection(design, html, css, apiRequestData, callbackFunc, enablePreview, skipUpdateHtml, enableSaveAsButton, true);
  }
}

function stripoInjection(design, html, css, apiRequestData, callbackFunc, enablePreview, skipUpdateHtml, enableSaveAsButton, alreadyLoaded) {
  window.Stripo.init({
    settingsId: 'load-controls',
    previewId: 'load-template',
    locale: 'en',
    html: html,
    css: css,
    notifications: {
      // info: notifications.info.bind(notifications),
      error: notifications.error.bind(notifications),
      // warn: notifications.warn.bind(notifications),
      // loader: notifications.loader.bind(notifications),
      // hide: notifications.hide.bind(notifications),
      // success: notifications.success.bind(notifications)
    },
    codeEditorButtonId: 'codeButton',
    undoButtonId: 'undoButton',
    redoButtonId: 'redoButton',
    apiRequestData: apiRequestData,
    userFullName: 'workbench XIQ',
    // enableNativeSpellChecker: true,
    mergeTags: [
      {
        category: 'xiQ Tags',
        entries: [
          { label: 'First Name', value: '*|FNAME|*' },
          { label: 'Last Name', value: '*|LNAME|*' },
          { label: 'Job Title', value: '*|JNAME|*' },
          { label: 'Company Name', value: '*|CNAME|*' },
          { label: 'Email', value: '*|EMAIL|*' },
          { label: 'Date', value: '*|DATE|*' },
          { label: 'Year', value: '*|YEAR|*' },
          { label: 'Username', value: '*|UNAME|*' },
          { label: 'Password', value: '*|PWORD|*' },
        ],
      },
    ],
    onTemplateLoaded: (callBack) => {
      stripo_onTemplateLoadedFunction(design, true, callbackFunc, skipUpdateHtml, enableSaveAsButton, enablePreview, alreadyLoaded);
    },
    unSubscribeLink: unsubLink,
    getAuthToken: (callback) => {
      authorizeStripo(callback);
    },
  });
}

function stripo_onTemplateLoadedFunction(design, flag, callbackFunc, skipUpdateHtml, enableSaveAsButton, enablePreview, alreadyLoaded) {
  // setTimeout(() => {
  //   templateLoad(design, true, callbackFunc, skipUpdateHtml, enableSaveAsButton);
  //   if (enablePreview) enablePreview();
  // }, 10);
  setTimeout(() => {
    templateLoad(design, true, callbackFunc, skipUpdateHtml, enableSaveAsButton);
    // handling preview button disable and enable
    // if (alreadyLoaded) {
    //   let disabledPreviewButton = store.getState().design.disablePreview;
    //   if (disabledPreviewButton) enablePreviewAction();
    // }
    if (enablePreview) enablePreview();
  }, 10);
}

async function init_stripo_plugin(design, template_style_id, callbackFunc = null, enablePreview, skipUpdatePageHtml = false, enableSaveAsButton) {
  $('#template-container').addClass('disabled');
  if (design === undefined) return;
  if (design?.user?.userid) {
    apiRequestData = {
      emailId: design.user.admin_id === null ? design.user.userid : design.user.admin_id,
      userId: design.user.userid,
    };
  }
  _template_style_id = template_style_id;
  _design = design;
  window.article_descriptions = [];
  if (window.article_descriptions.length <= 0) {
    load_articles_descriptions(design);
  }
  load_stripo(design, design.html, design.css, apiRequestData, callbackFunc, enablePreview, skipUpdatePageHtml, enableSaveAsButton);
}

function bindSideBarArticles() {
  // the following line is to mark articles on right side checked
  $('.personalize_articles_stripo').prop('checked', true);
  $('.plus-icon-wrapper').addClass('added');

  // the following few lines add the articles ids with section id in the object window.right_article_array
  // which will be used later in many places mainly to perform reorder issues
  window.right_article_array = [];
  $('.personalize_articles_stripo:checked').each(function (key, value) {
    window.right_article_array.push(value.id.split('article-')[1]);
  });

  var checkExist = setInterval(function () {
    $('.per-right-articles').sortable({
      animation: 150,
      ghostClass: 'dragging',
      axis: 'y',
      // Element dragging ended
      // onEnd not work on Firefox
      onEnd: function (/**Event*/ evt) {
        reArrangeArticles(SECTION_ID);
      },
      //stop work on firefox but not on chrome
      stop: function (/**Event*/ event, evt) {
        reArrangeArticles(SECTION_ID);
      },
    });

    clearInterval(checkExist);
  }, 1000); // 1 sec
}
function stripo_onTemplateLoaded(design, callback = false, callbackFunc = null, skipUpdateHtml, enableSaveAsButton) {
  try {
    designSkeletonLoad();
    if (callback) {
      init_stripo_plugin_callback(design, true, skipUpdateHtml);
    }
    var contents = $('.stripo-preview-frame').contents();
    appendStyle(contents);
    contents.find('.esd-block-text').attr('spellcheck', true).attr('role', 'textbox');
    // contents.find(".esd-block-text *").removeAttr("spellcheck").removeAttr("role");

    let staticEmail = store.getState().design.data.asset_type === 'custom';
    if (!staticEmail) {
      dragAndDropArticle();
      // $("body").removeClass("loader-stripe");
      template3_style($('.stripo-preview-frame').contents());
      // $(".sk-container").addClass("d-none");
      // $(contents)
      //   .find(".es-content")
      //   .on("mouseleave", function (event) {
      //     $(this).removeClass("active-section");
      //   });
      // $(contents)
      //   .find("style.esdev-css")
      //   .html(
      //     $(contents)
      //       .find("style.esdev-css")
      //       .html()
      //       .replace(/.msohide {[^}]+}?/g, "")
      //   );
      // $("html, body, #load-controls, #codeButton, #load-controls a, #load-controls li").on(
      //   "click",
      //   function (event) {
      //     hideSkeleton();
      //   }
      // );

      // $("#load-controls a[data-target='#collapseTwo']:not(.collapsed)").on("click", function (event) {
      //   $("#collapseTwo").addClass("esd-panel-deactivated");
      // });
      // $(contents)
      //   .find("html, body")
      //   .on("click", function (event) {
      //     hideSkeleton();
      //   });
      // $(contents)
      //   .find(".es-content")
      //   .on("mouseenter", function (event) {
      //     if ($(this).hasClass("in-section")) {
      //       $(this).addClass("active-section");
      //     }
      //   });
      $(contents).on('keyup mouseenter', function (event) {
        if (_template_style_id == 0 || _template_style_id == 2) {
          maintainHeight(contents);
        }
      });

      // A Hack fix to set the height of IFrame when screen is clicked to hide the code screen
      // $("document").on("click", () => {
      //   // SetTimeout is being used because the updated height is not received immediately
      //   hideSkeleton();
      //   //? just used the already created function from above
      //   // setTimeout(() => {
      //   //   const iFrameJqueryObject = $(".stripo-preview-frame");
      //   //   if (iFrameJqueryObject.css("height") === "0px") {
      //   //     iFrameJqueryObject.css("height", "inherit");
      //   //   }
      //   // }, 20);
      // });

      //in case of clone toggle of block not working
      // $(contents)
      //   .find("body")
      //   .find(".esd-frame")
      //   .on("click keyup", function (event) {
      //     $("#collapseTwo").addClass("in");
      //   });
      $(contents)
        .find('.articleProperties img[data-tag="article_image"]')
        .each(function () {
          let addwords = [
            'advert',
            'banner',
            'adwords',
            'adv',
            'ad',
            'adsens',
            'eader-ads',
            'adtech',
            'footer_ads',
            'sidebar-ads',
            '728x90',
            '468x60',
            '392х72',
            '336x280',
            '300x250',
            '300x6900',
            '250x250',
            '240x400',
            '234x60',
            '200х300',
            '180x150',
            '160x600',
            '125x125',
            '120x600',
            '120x240',
            '120x90',
            '120x60',
            '100х100',
            '88x31',
            '88X31',
            '728X90',
            '468X60',
            '392X72',
            '336X280',
            '300X250',
            '300X6900',
            '250X250',
            '240X400',
            '234X60',
            '200X300',
            '180X150',
            '160X600',
            '125X125',
            '120X600',
            '120X240',
            '120X90',
            '120X60',
            '100X100',
          ];
          let current_src = $(this).attr('src');
          if (
            current_src.indexOf('https://xiq-email-static.s3-us-west-2.amazonaws.com') < 0 &&
            current_src.indexOf('https://image.xiq.io/returnimage/') == 0
          ) {
            $.each(addwords, function (index) {
              current_src = current_src.replace(addwords[index], '');
            });
            $(this).attr('src', current_src);
          }
          let Image_itam = $(this);
          if (current_src.includes('https://image.xiq.io/returnimage/')) {
            UrlExists(current_src, function (status) {
              if (status !== 200) {
                $(Image_itam).attr('src', 'https://media.xiq.io/static/default_campaign_img.png');
              }
            });
          }
        });
      $(contents)
        .find('body')
        .on('click keyup', function (event) {
          //! commented the following line because it was causing the issue of removing the items from the dom and not including again upon re-initialization
          // if ($("#select-template .ant-collapse-header").attr("aria-expanded") == "true") {
          //   $("#select-template .ant-collapse-header").trigger("click");
          // }
          setTimeout(function () {
            // in case of opened templates it will scroll top by (140 + (the height of templates module)) else by 140px
            if ($('#select-template .ant-collapse-header').attr('aria-expanded') == 'true') {
              $('.settings-wraper .scrollable').scrollTop(140 + $('#select-template').height());
            } else {
              $('.settings-wraper .scrollable').scrollTop(140);
            }

            if (
              (($(event.target).is('[data-tag="article_description"]') ||
                $(event.target).find('[data-tag]').is('[data-tag="article_description"]') ||
                $(event.target).closest('p[data-tag="article_description"]').length) &&
                $.trim($('#linkText, #button-text-value-input').val()).toLowerCase() === 'read more') ||
              $.trim($('#linkText, #button-text-value-input').val()).toLowerCase() === 'watch video' ||
              $.trim($('#linkText, #button-text-value-input').val()).toLowerCase() === 'read the article'
            ) {
              $('#collapseTwo').addClass('disable-link');
              $('#link-url-href').closest('.input-group').attr('disabled', true);
            } else if (
              (($(event.target).is('[data-tag="article_link"]') || $(event.target).find('[data-tag]').is('[data-tag="article_link"]')) &&
                $.trim($('#linkText, #button-text-value-input').val()).toLowerCase() === 'read more') ||
              $.trim($('#linkText, #button-text-value-input').val()).toLowerCase() === 'watch video' ||
              $.trim($('#linkText, #button-text-value-input').val()).toLowerCase() === 'read the article'
            ) {
              $('#collapseTwo').addClass('disable-link');
              $('#link-url-href').closest('.input-group').attr('disabled', true);
            } else {
              $('#collapseTwo').removeClass('disable-link');
              $('#link-url-href').closest('.input-group').removeAttr('disabled');
            }
          }, 500);
          if ($(event.target).hasClass('load-more')) {
            load_more_text($(event.target).closest('[data-article]'));
          }
        });

      $(contents).on('DOMSubtreeModified', "[data-tag='article_title']", function () {
        $('.per-right-articles .sidebar-article#' + $(this).closest('[data-article]').attr('id') + ' .title').text(
          $(this).closest('.esd-block-text').find("[data-tag='article_title']").text(),
        );
      });
      $(contents)
        .find("img[data-tag='article_image']")
        .on('load', function () {
          var url = new URL($(this).attr('src'));
          url.searchParams.set('width', '150');
          url.searchParams.set('height', '150');
          $('.per-right-articles .sidebar-article#' + $(this).closest('[data-article]').attr('id') + ' .img-wrap img').attr('src', url.href);
        });

      $(contents)
        .find('.articleProperties [data-drag] img')
        .attr('src', 'https://media.xiq.io/user_images/1600794455_1c4c2182-fcf6-11ea-8308-0a723d0dce2e.svg');

      setTimeout(function () {
        bindImagesWithTemplate();
      }, 1500);

      // synchronize Sidebar Article image and title on undo and redo
      $('#undoButton, #redoButton').on('click', function () {
        setTimeout(function () {
          $(contents)
            .find("img[data-tag='article_image']")
            .each(function (index) {
              var url = new URL($(this).attr('src'));
              url.searchParams.set('width', '150');
              url.searchParams.set('height', '150');
              $('.per-right-articles .sidebar-article#' + $(this).closest('[data-article]').attr('id') + ' .img-wrap img').attr('src', url.href);
            });
          $(contents)
            .find("[data-tag='article_title']")
            .each(function (index) {
              $('.per-right-articles .sidebar-article#' + $(this).closest('[data-article]').attr('id') + ' .right-side .title').text(
                $(this).closest('.esd-block-text').find("[data-tag='article_title']").text(),
              );
            });
          $(contents).find('body').css('opacity', '1'); // when undo/redo opacity will be set to 1
          maintainHeight(contents);
          $(contents)
            .contents()
            .find('[data-drag] td')
            .html(
              '<span class="drag ui-draggable ui-draggable-handle" style="position: relative; top: 0px; left: 0px;">\n' +
                '<a class="esd-frame-element esd-hover-element esdev-disable-select">\n' +
                '<img src="https://media.xiq.io/user_images/1600794455_1c4c2182-fcf6-11ea-8308-0a723d0dce2e.svg" style="display: inline; width: 15px; height: 14px; border-width: 0px;" class="esd-frame-element esd-hover-element esdev-disable-select" alt="">\n' +
                '</a></span>',
            );
          dragAndDropArticle();
        }, 1500);
        // call maintain order and state of article on undo / redo
        setTimeout(function () {
          dragAndDropArticle();
          bindImagesWithTemplate();
          matchArticleOrder();
          reset_description_counter();
        }, 500);
      });

      // update date on header when content displayed
      update_header_date(contents);

      $(contents).mouseup(function () {
        update_header_date(contents);
      });

      if (_template_style_id === 0 || _template_style_id === 2) {
        maintainHeight(contents);
      }

      if (_template_style_id == 1) {
        adjust_height(contents);
      }
      loadImages();
      $('.template-col.template-col-sidbar a').removeClass('active');
      $('.template-col.template-col-sidbar a[data-template-id=' + _template_style_id?.toString() + ']').addClass('active');

      $(contents)
        .find('.es-content[id]')
        .each(function () {
          reArrangeArticles(SECTION_ID);
        });
      $('.per-right-articles .single-article-wrap .personalize_articles_stripo.uncheck-this').each(function (index) {
        $(this).prop('checked', false).trigger('change').removeClass('uncheck-this');
      });
      $(contents).bind('keypress keyup', function (e) {
        if (e.which === 90 || e.ctrlKey || e.which === 25) {
          setTimeout(function () {
            dragAndDropArticle();
            bindImagesWithTemplate();
            matchArticleOrder();
            reset_description_counter();
          }, 500);
        }
      });
      bindSideBarArticles();
      $('#template-container').removeClass('disabled');
      designSkeletonLoadSuccess();
      enablePreviewAction(); // enable Preview Button
      enablePublishButton(); // enable Publish Button
      if (callbackFunc && !window.location.pathname.includes('design')) {
        getEmailContent(callbackFunc);
        return;
      }
    }
    if (callbackFunc) callbackFunc(_design);
    if (callbackFunc && enableSaveAsButton) {
      callbackFunc(false);
    }
  } catch (err) {
    console.log(err);
  }
}
function setTemplate() {
  $('.template-col.template-col-sidbar a').removeClass('active');
  $('.template-col.template-col-sidbar a[data-template-id=' + _template_style_id?.toString() + ']').addClass('active');
}
// function update_articles_array(id_value = "0") {
//   var index = window.right_article_array.indexOf(id_value);
//   if (index > -1) {
//     window.right_article_array.splice(index, 1);
//   }
//   $("#articles_count").html(window.right_article_array.length);
// }

// Header date update
function update_header_date(contents) {
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var d = new Date();
  var m = months[d.getMonth()];
  var whole_date = m + ' ' + d.getDate() + ', ' + d.getFullYear();
  contents.find('[data-date]').text(whole_date);
}

function get_article_div_text(div, data_attribute) {
  var selector = "[data-tag='" + data_attribute + "']";
  var all_paras = div.find(selector);
  var final_text = '';
  all_paras.each(function (index, val) {
    var new_text = $.trim($(val).text());

    if (index == all_paras.length - 1 && data_attribute == 'article_description') {
      new_text = new_text.replace(/...\s+Read More/g, '').replace(/...\s+READ MORE/g, '');
    } else if (index < all_paras.length - 1) {
      new_text += ' ';
    }
    final_text += new_text;
  });
  return final_text;
}
function showLoader(value) {
  if (value === true) {
    $('#load-template').addClass('stripo-hide');
    $('.sk-container').removeClass('stripo-hide');
    $('.sk-container').removeClass('d-none');
  } else {
    $('.sk-container').addClass('stripo-hide');
    $('.sk-container').addClass('d-none');
    $('#load-template').removeClass('stripo-hide');
    $('#load-template').removeClass('d-none');
  }
}
function check_modified_articles(current_HTML, saveAsEmail) {
  try {
    var current_html_div = $('<div>').attr({
      type: 'hidden',
      id: 'foo',
      name: 'bar',
    });
    var old_html_div = $('<div>').attr({
      type: 'hidden',
      id: 'foo2',
      name: 'bar2',
    });

    current_html_div.html(current_HTML);
    old_html_div.html(window.page_HTML);

    var changes_articles = {};
    if (saveAsEmail) {
      var list_articles_ids = [];
      $('.per-right-articles .single-article-wrap :checked').each(function (index, item) {
        list_articles_ids.push(item.id.split('-')[2]);
      });
      $(old_html_div)
        .contents()
        .find('[data-article]')
        .each(function (index, article) {
          var old_article = $(article);
          var article_id = old_article.attr('id');
          if (list_articles_ids.indexOf(article_id.split('-')[1]) > -1) {
            if (article_id !== '' && article_id !== 'hero_article_structure') {
              changes_articles[article_id] = {};

              var current_article = $(current_html_div)
                .contents()
                .find('#' + article_id);
              var article_changed_flag = false;

              // Checking for image
              var old_image = old_article.find('[data-tag="article_image"]');
              var current_image = current_article.find('[data-tag="article_image"]');
              if (current_image.length > 0 && old_image.length > 0) {
                var oldSource = new URL(old_image.attr('src'));

                var currentSource = new URL(current_image.attr('src'));
                if (currentSource['pathname'] == '/returnimage/') {
                  //    URL is using returnimage api so check url param in source
                  if (oldSource.searchParams.get('url') !== currentSource.searchParams.get('url')) {
                    // article_changed_flag = true;
                    changes_articles[article_id]['image'] = currentSource.searchParams.get('url');
                  }
                } else {
                  var current_url = currentSource.origin + currentSource.pathname;
                  var old_url = oldSource.origin + oldSource.pathname;
                  if (current_url !== old_url) {
                    // article_changed_flag = true;
                    changes_articles[article_id]['image'] = current_url;
                  }
                }
              }

              try {
                var old_tag = old_article.find('[data-tag="tag_name"]').last().closest('td');
                var current_tag = current_article.find('[data-tag="tag_name"]').last().closest('td');

                if (old_tag.parent().html() !== current_tag.parent().html()) {
                  article_changed_flag = true;
                  var tag_name = get_article_div_text(current_tag, 'tag_name');
                  changes_articles[article_id]['workbench_tag_name'] = tag_name;
                  changes_articles[article_id]['workbench_tag_color'] = current_tag.attr('bgcolor');
                }
              } catch (e) {
                changes_articles[article_id]['workbench_tag_name'] = '';
                changes_articles[article_id]['workbench_tag_color'] = '';
              }

              //Checking For title
              var old_title = old_article.find('[data-tag="article_title"]').last().closest('td');
              var current_title = current_article.find('[data-tag="article_title"]').last().closest('td');
              if ($.trim(old_title.text()) !== $.trim(current_title.text())) {
                var title = get_article_div_text(current_title, 'article_title');
                changes_articles[article_id]['title'] = title;
              }

              //Checking For domain
              var old_domain = old_article.find('[data-tag="article_domain"]').last().closest('td');
              var current_domain = current_article.find('[data-tag="article_domain"]').last().closest('td');
              if ($.trim(old_domain.text()) !== $.trim(current_domain.text())) {
                var domain = get_article_div_text(current_domain, 'article_domain');
                changes_articles[article_id]['domain'] = domain;
              }
              // Checking for description
              var old_desc = old_article.find('[data-tag="article_description"]').last().closest('td');
              var current_desc = current_article.find('[data-tag="article_description"]').last().closest('td');
              if ($.trim(old_desc.text()) !== $.trim(current_desc.text())) {
                var new_desc = get_article_div_text(current_desc, 'article_description');
                var desc = window.article_descriptions[article_id];
                if (desc !== '') {
                  var full_desc = desc['full_description'].slice(desc['counter']);
                  new_desc += full_desc;
                  changes_articles[article_id]['description'] = new_desc;
                }
              }
              changes_articles[article_id]['checked'] = $('#article-' + article_id).prop('checked');
            }
          }
        });
    } else {
      $(old_html_div)
        .contents()
        .find('[data-article]')
        .each(function (index, article) {
          var old_article = $(article);
          var article_id = old_article.attr('id');
          if (article_id !== '' && article_id !== 'hero_article_structure') {
            changes_articles[article_id] = {};
            var current_article = $(current_html_div)
              .contents()
              .find('#' + article_id);
            var article_changed_flag = false;

            // Checking for image
            var old_image = old_article.find('[data-tag="article_image"]');
            var current_image = current_article.find('[data-tag="article_image"]');
            if (current_image.length > 0 && old_image.length > 0) {
              var oldSource = new URL(old_image.attr('src'));

              var currentSource = new URL(current_image.attr('src'));
              if (currentSource['pathname'] == '/returnimage/') {
                //    URL is using returnimage api so check url param in source
                if (oldSource.searchParams.get('url') !== currentSource.searchParams.get('url')) {
                  // article_changed_flag = true;
                  changes_articles[article_id]['image'] = currentSource.searchParams.get('url');
                }
              } else {
                var current_url = currentSource.origin + currentSource.pathname;
                var old_url = oldSource.origin + oldSource.pathname;
                if (current_url !== old_url) {
                  // article_changed_flag = true;
                  changes_articles[article_id]['image'] = current_url;
                }
              }
            }

            try {
              var old_tag = old_article.find('[data-tag="tag_name"]').last().closest('td');
              var current_tag = current_article.find('[data-tag="tag_name"]').last().closest('td');

              if (old_tag.parent().html() !== current_tag.parent().html()) {
                article_changed_flag = true;
                var tag_name = get_article_div_text(current_tag, 'tag_name');
                changes_articles[article_id]['workbench_tag_name'] = tag_name;
                changes_articles[article_id]['workbench_tag_color'] = current_tag.attr('bgcolor');
              }
            } catch (e) {
              changes_articles[article_id]['workbench_tag_name'] = '';
              changes_articles[article_id]['workbench_tag_color'] = '';
            }

            //Checking For title
            var old_title = old_article.find('[data-tag="article_title"]').last().closest('td');
            var current_title = current_article.find('[data-tag="article_title"]').last().closest('td');
            if ($.trim(old_title.text()) !== $.trim(current_title.text())) {
              var title = get_article_div_text(current_title, 'article_title');
              changes_articles[article_id]['title'] = title;
            }

            //Checking For domain
            var old_domain = old_article.find('[data-tag="article_domain"]').last().closest('td');
            var current_domain = current_article.find('[data-tag="article_domain"]').last().closest('td');
            if ($.trim(old_domain.text()) !== $.trim(current_domain.text())) {
              var domain = get_article_div_text(current_domain, 'article_domain');
              changes_articles[article_id]['domain'] = domain;
            }
            // Checking for description
            var old_desc = old_article.find('[data-tag="article_description"]').last().closest('td');
            var current_desc = current_article.find('[data-tag="article_description"]').last().closest('td');
            if ($.trim(old_desc.text()) !== $.trim(current_desc.text())) {
              var new_desc = get_article_div_text(current_desc, 'article_description');
              var desc = window.article_descriptions[article_id];
              if (desc !== '') {
                var full_desc = desc['full_description'].slice(desc['counter']);
                new_desc += full_desc;
                changes_articles[article_id]['description'] = new_desc;
              }
            }

            if (Object.keys(changes_articles[article_id]).length === 0) {
              // Delete that article if article is not modified
              delete changes_articles[article_id];
            } else {
              changes_articles[article_id]['checked'] = $('#article-' + article_id).prop('checked');
            }
          }
        });
    }

    $(current_html_div).remove();
    $(old_html_div).remove();
    return changes_articles;
  } catch (e) {
    console.log(e);
  }
}

function rerender_after_save(design) {
  if (window.article_descriptions.length <= 0) {
    load_articles_descriptions(design);
  }
  window.right_article_array = design.section[0].articles;
}

function template3_style(contents) {
  if (parseInt(_template_style_id) === 2) {
    $(contents).find('[data-article]>tbody>tr>td, td[data-article]').attr('bgcolor', '#f6f6f6').css('background-color', 'rgb(246, 246, 246)');
    $('<tr class="feature-story">' + $(contents).find('#feature-story').html() + '</tr>').insertBefore(
      $(contents).find('td[data-article]:first').closest('tr'),
    );
  } else {
    $(contents).find('[data-article]>tbody>tr>td, td[data-article]').attr('bgcolor', '#ffffff').css('background-color', '#ffffff');
    // .removeAttr("bgcolor")
    // .css("background-color", "transparent");
    $(contents).find('.feature-story').remove();
  }
}

function template3_reorder_style(contents) {
  $(contents).find('.feature-story').remove();
  $('<tr class="feature-story">' + $(contents).find('#feature-story').html() + '</tr>').insertBefore(
    $(contents).find('td[data-article]:first').closest('tr'),
  );
  $(contents)
    .find('[data-article]>tbody>tr>td .es-button-border')
    .closest('table')
    .closest('td')
    .addClass('es-p25r es-p25l')
    .removeClass('es-m-p0l es-m-p0r');
  $(contents).find('td[data-article] .es-button-border').closest('table').closest('td').removeClass('es-p25r es-p25l').addClass('es-m-p0l es-m-p0r');
  $(contents).find('td[data-article] .esd-block-spacer').closest('tr').css('display', 'none');
  $(contents).find('td[data-article] .esd-block-text').removeClass('es-p25r es-p25l es-m-p20r es-m-p20l').addClass('es-m-p0l es-m-p0r');
  $(contents).find('[data-article]>tbody>tr>td .esd-block-text').addClass('es-p25r es-p25l').removeClass('es-m-p0l es-m-p0r');
  $(contents).find('[data-article]>tbody>tr>td .esd-block-spacer').closest('tr').css('display', 'table-row');
  $(contents).find('table[data-article] .esd-block-image').css('border', '');
  $(contents).find('td[data-article] .esd-block-image').css('border', '1px solid #000');
  $(contents)
    .find('[id^=section-] [data-article]>tbody>tr>td')
    .each(function (index) {
      if ($.inArray(index, [0, 3, 4, 7, 8, 11, 12, 15, 16, 19, 20]) >= 0) {
        $(this).find('.esd-block-spacer').attr('bgcolor', '#45afe3');
        $(this).find('.esd-block-spacer td').css('border-color', '#45afe3');
        $(this).find('.esd-block-spacer td').attr('data-td', '08');
      } else {
        $(this).find('.esd-block-spacer').attr('bgcolor', '#f09928');
        $(this).find('.esd-block-spacer td').css('border-color', '#f09928');
        $(this).find('.esd-block-spacer td').attr('data-td', '09');
      }
    });
}
function template4_reorder_style(contents) {
  var readMoreText = '';
  var readMoreLink = '';
  var totalArticles = $(contents).find('[data-article]:visible').length;
  $(contents)
    .find('[data-article]:visible')
    .each(function (index) {
      $(this).find('img[data-tag=article_image]').closest('tr').remove();
      readMoreText = $.trim($(this).find('[data-tag=article_link]').text());
      readMoreLink = $(this).find('[data-tag=article_link]').attr('href');
      $(this).find('[data-tag=article_link]').closest('tr').remove();
      $(this).find('.articleProperties tr[data-spacer-row]').removeAttr('style').removeAttr('spacer-row');
      $(this).removeClass('hero-article');
      if (index === 0) {
        $(this).addClass('hero-article');
        $(this).find('.esd-block-spacer').removeClass('es-p30r es-p30l es-m-p25r es-m-p25l');
        $(this)
          .find('.articleProperties tr[data-drag]')
          .after('<tr data-hover>' + $(contents).find('#article-image').html() + '</tr>');
        let _img_url = $('#' + $(this).attr('id') + ' .blog-image img').attr('src');
        if (_img_url === undefined || _img_url === '') {
          let imageURL_From_redux = store.getState().design?.data?.section[0]?.articles[0]?.article_image;
          _img_url = decodeURIComponent(imageURL_From_redux);
        }
        var heroUrl = new URL(_img_url);
        heroUrl.searchParams.set('width', '600');
        heroUrl.searchParams.set('height', '185');
        $(this).find('.articleProperties img[data-tag=article_image]').attr('src', heroUrl.href);
        $(this)
          .find('.articleProperties tr[data-load]')
          .after('<tr data-hover>' + $(contents).find('#article-btn').html() + '</tr>');
        $(this)
          .find('[data-tag=article_link]')
          .closest('td')
          .html(
            $(this)
              .find('[data-tag=article_link]')
              .closest('td')
              .html()
              .toString()
              .replace('href=""', 'href="' + readMoreLink + '"')
              .replace('href=""', 'href="' + readMoreLink + '"')
              .replace('Read the Article', readMoreText),
          );
      } else {
        $(this).find('.esd-block-spacer').addClass('es-p30r es-p30l es-m-p25r es-m-p25l');
        $(this)
          .find('.articleProperties tr[data-load]')
          .after('<tr data-hover>' + $(contents).find('#article-link').html() + '</tr>');
      }
      $(this).find('[data-tag=article_link]').attr('href', readMoreLink).text(readMoreText);
      if (index === totalArticles - 1) {
        $(this).find('.articleProperties tr[data-spacer-row]').css('display', 'none').attr('spacer-row', '');
      }
    });
}
function template5_reorder_style_2(contents) {
  var totalArticles = $(contents).find('[data-article]').length;
  $(contents)
    .find('[data-article]')
    .each(function (index) {
      $(this).find('.articleProperties tr[data-spacer-row]').removeAttr('style').removeAttr('spacer-row');
      if (index === 0) {
        // $(this).addClass("hero-article");
        $(this).find('.articleProperties table[data-left-col-table]').attr('width', '310');
        $(this).find('.articleProperties table[data-right-col-table]').removeClass('d-none');
        const articleDomain = $(this).find('[data-tag=data-article-domain-name]').text().trim();
        const articlesTagsUp = $(this).find('[data-tag=data-article-tags]').text().trim();
        const words = articlesTagsUp.split(',').map((item) => item.trim());
        const joined = words.join(', ');
        let domainLength = articleDomain.length;
        const truncated =
          joined.length > 30 || domainLength > 15 ? joined.substring(0, domainLength > 15 ? 30 - (domainLength - 15) : 30) + '...' : joined;
        $(this)
          .find('[data-tag=data-article-tags]')
          .html(
            `<p style="color: #46B0E6;font-size: 11px; font-family: roboto, 'helvetica neue', helvetica, arial, sans-serif; margin: 0px;">` +
              truncated +
              `</p>`,
          );
      } else {
        // $(this).removeClass("hero-article");
        $(this).find('.esd-block-spacer').addClass('es-p30r es-p30l');
        $(this).find('.articleProperties table[data-left-col-table]').attr('width', '540');
        $(this).find('.articleProperties td[data-left-col-td]').attr('width', '540');
        $(this).find('.articleProperties table[data-right-col-table]').addClass('d-none');
        $(this).find('.articleProperties .mso-table-wrap .mso-table-td-left').attr('width', '540');
        $(this).find('.articleProperties .mso-table-wrap .mso-table-td-right').addClass('d-none');
        const articlesTagsDown = $(this).find('[data-tag=data-article-tags]').text().trim();
        const words = articlesTagsDown.split(',').map((item) => item.trim());
        const joinedDown = words.join(', ');
        $(this)
          .find('[data-tag=data-article-tags]')
          .html(
            `<p style="color: #46B0E6;font-size: 11px; font-family: roboto, 'helvetica neue', helvetica, arial, sans-serif; margin: 0px;">` +
              joinedDown +
              `</p>`,
          );
      }
      if (index === totalArticles - 1) {
        $(this).find('.articleProperties tr[data-spacer-row]').css('display', 'none').attr('spacer-row', '');
      }
      // $(this).find(".articleProperties td[data-tag=article-struct-td]").addClass('es-p30');
      // if (index === (totalArticles - 1)) {
      //   $(this).find(".articleProperties tr[data-tag=spacer-row]").addClass('d-none');
      // } else {
      //   $(this).find(".articleProperties tr[data-tag=spacer-row]").removeClass('d-none');
      // }
    });
}

function load_more_text(article) {
  var counter_inc = 0;
  var last_p = '';
  if (article.attr('class').indexOf('esd-structure') >= 0) {
    counter_inc = 100;
  } else {
    counter_inc = 50;
  }
  var article_desc = article.find('[data-tag="article_description"]');
  var tagName = article_desc.prop('tagName');
  if (tagName == 'tr') {
    last_p = article_desc.find('p').last();
  } else {
    last_p = article.find('[data-tag="article_description"]').last();
  }
  var read_more = last_p.find('[data-tag="article_link"]');
  var read_more_clone = read_more.clone();

  var desc = window.article_descriptions[article.attr('id')];
  var counter = desc['counter'];
  var full_description = desc['full_description'];

  var new_desc = full_description.slice(counter, counter + counter_inc);
  new_desc = new_desc.slice(0, new_desc.lastIndexOf(' ')) + ' ';

  if (new_desc.length && read_more.prop('tagName') != 'p') {
    desc['counter'] = desc['counter'] + new_desc.length;
    read_more.remove();
    last_p.html(function (i, v) {
      v = v.replace('...', '');
      return $.trim(v) + ' ' + new_desc + '...' + $('<div>').append(read_more_clone).html();
    });
  }

  if (parseInt(_template_style_id) === 0 || parseInt(_template_style_id) === 2) {
    maintainHeight($('.stripo-preview-frame').contents());
  }
}

// filter titles if copy and paste in article title
function filter_title(contents) {
  $(contents)
    .find("[data-tag='article_title']")
    .closest('.esd-block-text')
    .find('strong')
    .each(function (index, val) {
      $(val).attr('data-tag', 'article_title');
      if ($.trim($(val).text()).length < 1) {
        $(val).remove();
      }
    });
}
// maintain order and state of article on undo / redo
function matchArticleOrder() {
  var contents = $('.stripo-preview-frame').contents(); // contents of the iframe
  maintainHeight(contents);
  window.right_article_array = [];
  contents.find('.es-content').each(function (i, section) {
    var section_id = section['id'].split('-')[1];
    if (typeof section_id !== 'undefined') {
      var section = $(section);
      var right_side_articles = $('#collapse-article-section-' + section_id).find('.single-article-wrap ');
      var temp_right_articles = right_side_articles.parent().clone();
      var new_order = [];
      section.find('[data-article]').each(function (index, article) {
        new_order.push(article['id']);
      });
      var to_be_deleted = [];
      right_side_articles.each(function (index, article) {
        var found = $.inArray(article['id'], new_order);
        if (found === -1) {
          to_be_deleted.push(article['id']);
        }
      });
      // ? commenting the following code as it unbinds the events
      right_side_articles.each(function (index, article) {
        article = $(article);
        if (index < new_order.length) {
          var temp_article = temp_right_articles.find('#' + new_order[index]);
          article.html(temp_article.html());
          article.attr('id', temp_article.attr('id'));
          article.attr('data-id', temp_article.attr('data-id'));
          $('#' + SECTION_ID + '-' + temp_article.attr('data-id') + ' .plus-icon-wrapper').addClass('added');
          $('#' + SECTION_ID + '-' + temp_article.attr('data-id') + ' .plus-icon-wrapper .personalize_articles_stripo').prop('checked', true);
          // article.find("#article-" + temp_article.attr("data-id")).prop("checked", true);
          window.right_article_array.push(temp_article.attr('id'));
        } else {
          var temp_article = temp_right_articles.find('#' + to_be_deleted[index - new_order.length]);
          article.html(temp_article.html());
          article.attr('id', temp_article.attr('id'));
          article.attr('data-id', temp_article.attr('data-id'));
          // article.find("#article-" + temp_article.attr("id")).prop("checked", false);
          $('#' + SECTION_ID + '-' + temp_article.attr('data-id') + ' .plus-icon-wrapper').removeClass('added');
          $('#' + SECTION_ID + '-' + temp_article.attr('data-id') + ' .plus-icon-wrapper .personalize_articles_stripo').prop('checked', false);
        }
      });
    }
  });
}
function loadImages() {
  $('img[data-src]').each(function () {
    $(this).attr('src', $(this).attr('data-src'));
  });
}
//bind images with template
function bindImagesWithTemplate() {
  var contents = $('.stripo-preview-frame').contents();
  $(contents)
    .find("img[data-tag='article_image']")
    .on('load', function () {
      var url = new URL($(this).attr('src'));
      url.searchParams.set('width', '150');
      url.searchParams.set('height', '150');
      $('.per-right-articles .sidebar-article#' + $(this).closest('[data-article]').attr('id') + ' .img-wrap img').attr('src', url.href);
    });
}

function reArrangeArticles(section_id) {
  var afterIds = [];
  $('.personalize_articles_stripo:checked').each(function (key, value) {
    if (value.id.split('-')[1] === section_id) {
      afterIds.push(value.id.split('article-')[1]);
    }
  });
  var section = $('.stripo-preview-frame')
    .contents()
    .find('#section-' + section_id);
  var temp_section = section.clone();
  section.find('[data-article]').each(function (index, article) {
    article = $(article);
    deleted_articles[article.attr('id')] = article.find('.articleProperties').html();
    var id = afterIds[index];
    var newArticle = temp_section.find('#' + id);
    // check if HTML found in section or get from deleted_articles dictionary
    newArticle = newArticle.find('.articleProperties');
    image_resize(article, newArticle);
    article.find('.articleProperties').html(newArticle?.html());
    article.attr('id', id);
  });
  window.right_article_array = [];
  $('.personalize_articles_stripo:checked').each(function (key, value) {
    window.right_article_array.push(value.id.split('article-')[1]);
  });
  dragAndDropArticle();
  bindImagesWithTemplate();
  if (_template_style_id == 0 || _template_style_id == 2) {
    maintainHeight($('.stripo-preview-frame').contents());
  }

  if (_template_style_id == 1) {
    adjust_height($('.stripo-preview-frame').contents());
  }

  if (_template_style_id == 2) {
    template3_reorder_style($('.stripo-preview-frame').contents());
  }
  if (_template_style_id == 3) {
    template4_reorder_style($('.stripo-preview-frame').contents());
  }
  if (_template_style_id == 4) {
    template5_reorder_style_2($('.stripo-preview-frame').contents());
  }
}

function adjust_height(contents) {
  $(contents)
    .find('.articleProperties')
    .each(function (index) {
      if ($(this).closest('[defaults]').length < 1) {
        if (!$(this).closest('[data-article]').hasClass('esd-structure')) {
          $(this).closest('.esd-structure').find('[data-article] > tbody > tr > td').css('height', 'auto');
        }
      }
    });
}

function UrlExists(url, cb) {
  $.ajax({
    url: url,
    dataType: 'text',
    type: 'GET',
    complete: function (xhr) {
      if (typeof cb === 'function') cb.apply(this, [xhr.status]);
    },
  });
}

// maintain Height of small articles on template load and on change order
// only for default template style ID = 0
function maintainHeight(contents) {
  var articleHeight = '';
  var articleTextHeight = '';
  var articleTitleHeight = '';
  $(contents)
    .find('.articleProperties')
    .each(function (index) {
      if ($(this).closest('[defaults]').length < 1) {
        if (!$(this).closest('[data-article]').hasClass('esd-structure')) {
          $(this).closest('.esd-structure').find('[data-article] > tbody > tr > td').css('height', 'auto');
          articleHeight =
            Math.max(
              $(this).closest('.esd-structure').find('[data-article] > tbody > tr > td').eq(0).outerHeight(),
              $(this).closest('.esd-structure').find('[data-article] > tbody > tr > td').eq(1).outerHeight(),
            ) + 5;
          $(this)
            .closest('.esd-structure')
            .find('[data-article] > tbody > tr > td')
            .css('height', articleHeight + 'px');

          $(this)
            .closest('.esd-structure')
            .find('[data-article] > tbody > tr > td td')
            .css('height', 'auto')
            .css('box-sizing', 'content-box')
            .css('vertical-align', 'top');

          if (_template_style_id == 2) {
            articleTextHeight = Math.max(
              $(this).closest('.esd-structure').find('[data-article] > tbody > tr > td').eq(0).find("td[data-td='description-td']").outerHeight(),
              $(this).closest('.esd-structure').find('[data-article] > tbody > tr > td').eq(1).find("td[data-td='description-td']").outerHeight(),
            );
            $(this)
              .closest('.esd-structure')
              .find("[data-article] > tbody > tr > td td[data-td='description-td']")
              .css('height', articleTextHeight + 'px');

            articleTitleHeight =
              Math.max(
                $(this).closest('.esd-structure').find('[data-article] > tbody > tr > td').eq(0).find("td[data-td='title-td']").outerHeight(),
                $(this).closest('.esd-structure').find('[data-article] > tbody > tr > td').eq(1).find("td[data-td='title-td']").outerHeight(),
              ) - 40;
            $(this)
              .closest('.esd-structure')
              .find("[data-article] > tbody > tr > td td[data-td='title-td']")
              .css('height', articleTitleHeight + 'px')
              .css('display', 'block');
          }
        } else {
          $(this).closest('.esd-structure[data-article]').find('tbody > tr > td td').css('height', 'auto');
        }
      }
    });
}

// update article in list reorder articles
function updateArticleList(dragArticleId, dropArticleId) {
  try {
    if (dragArticleId !== dropArticleId) {
      var dragHTML = $('.per-right-articles  .sidebar-article#' + dragArticleId)
        .parent()
        .html();
      var dropHTML = $('.per-right-articles .sidebar-article#' + dropArticleId)
        .parent()
        .html(); // .single-article-wrap#
      var dragHTMLIndex = $('.per-right-articles .sidebar-article#' + dragArticleId)
        .parent()
        .index();
      var dropHTMLIndex = $('.per-right-articles .sidebar-article#' + dropArticleId)
        .parent()
        .index();
      // console.log(dragHTMLIndex + " " + dropHTMLIndex);
      if (dragHTMLIndex < dropHTMLIndex) {
        $('.per-right-articles .sidebar-article#' + dropArticleId)
          .parent()
          .html(dragHTML);
        $('.per-right-articles .sidebar-article#' + dragArticleId)
          .parent()
          .html(dropHTML);
      } else {
        $('.per-right-articles .sidebar-article#' + dragArticleId)
          .parent()
          .html(dropHTML);
        $('.per-right-articles .sidebar-article#' + dropArticleId)
          .parent()
          .html(dragHTML);
      }
      $('.per-right-articles .sidebar-article#' + dragArticleId + ' .personalize_articles_stripo').prop('checked', true);
      $('.per-right-articles .sidebar-article#' + dropArticleId + ' .personalize_articles_stripo').prop('checked', true);
    }
    reArrangeArticles(SECTION_ID);
  } catch (err) {
    console.log(err);
  }
}
function dragAndDropArticle() {
  var contents = $('.stripo-preview-frame').contents(); // contents of the iframe
  var dragArticleId = '';
  $(contents)
    .find('.drag')
    .draggable({
      revert: 'invalid',
      create: function (event, ui) {
        $(this).css('top', '0px').css('left', '0px');
      },
      start: function (event, ui) {
        $('.stripo-preview-frame').contents().find('body').css('opacity', '0.6').css('cursor', 'all-scroll');
        dragArticleId = $(this).closest('[data-article]').attr('id');
        $(this).closest('.es-content').addClass('active-section in-section');
      },
      stop: function (event, ui) {
        $('.stripo-preview-frame').contents().find('body').css('opacity', '1').css('cursor', 'auto');
        $(this).css('top', '0px').css('left', '0px');
        dragArticleId = $(this).closest('[data-article]').attr('id');
        $(this).closest('.es-content').removeClass('active-section in-section');
      },
    });

  $(contents)
    .find('.drop')
    .droppable({
      drop: function (event, ui) {
        if (dragArticleId.length > 1) {
          $('.stripo-preview-frame')
            .contents()
            .find('#' + dragArticleId)
            .find('[data-drag] td')
            .html(
              '<span class="drag ui-draggable ui-draggable-handle" style="position: relative; top: 0px; left: 0px;">\n' +
                '<a class="esd-frame-element esd-hover-element esdev-disable-select">\n' +
                '<img src="https://media.xiq.io/user_images/1600794455_1c4c2182-fcf6-11ea-8308-0a723d0dce2e.svg" style="display: inline; width: 15px; height: 14px; border-width: 0px;" class="esd-frame-element esd-hover-element esdev-disable-select" alt="">\n' +
                '</a></span>',
            );
          updateArticleList(dragArticleId, $(this).closest('[data-article]').attr('id'));
          dragAndDropArticle();
          bindImagesWithTemplate();
        }
      },
    });
}
function processEmailHTML(current_HTML) {
  try {
    if ($('#ifrmhidden').length == 0) {
      var ifrm = document.createElement('iframe');
      ifrm.setAttribute('id', 'ifrmhidden'); // assign an id
    } else {
      var ifrm = document.getElementById('ifrmhidden');
    }
    document.body.appendChild(ifrm); // to place at end of document
    $('#ifrmhidden').css('width', '100%').css('display', 'block');
    var iframeHtml = $('#ifrmhidden').contents().find('html').get(0);
    iframeHtml.innerHTML = current_HTML;
    var hidden_div = $('#ifrmhidden').contents();
    // hidden_div = $('<div>').attr({type: 'hidden', id: 'foo', name: 'bar'});
    // hidden_div.html(current_HTML);
    $(hidden_div).find('[data-drag]').remove();
    $(hidden_div).find('[data-load]').remove();
    $(hidden_div).find('td[data-article] [spacer-row]').remove();
    // $(hidden_div).find('[data-border]').css('height', '-=36');
    $(hidden_div).find('table[data-article] > tbody > tr > td').css('height', '-=32');
    $(hidden_div).find('[data-hover]').css('display', '');
    var current_HTML = iframeHtml.innerHTML;
    $('#ifrmhidden').hide();
    return (
      '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office">' +
      current_HTML +
      '</html>'
    );
  } catch (e) {
    console.log(e);
    return current_HTML;
  }
}
//On template load, save hero and small articles structures from defaults and save page html for changes comparison
function load_hero_small_structure_template(skipUpdateHtml) {
  hero_article_structure = $('.stripo-preview-frame').contents().find('#hero_article_structure').parent().clone();
  hero_article_structure.find('#hero_article_structure').removeAttr('id');
  small_articles_structure = $('.stripo-preview-frame').contents().find('#small_articles_structure').parent().clone();
  small_articles_structure.find('#small_articles_structure').removeAttr('id');
  if (skipUpdateHtml) return;
  window.StripoApi.compileEmail(function (error, html) {
    window.page_HTML = html;
  });
}
function reset_description_counter() {
  $('.stripo-preview-frame')
    .contents()
    .find('[data-article]')
    .each(function (index, article) {
      article = $(article);
      var article_id = article.attr('id');
      if (article_id !== '' && article_id !== 'hero_article_structure') {
        // if (article_id == ' 8621-338953756') {
        var all_paras = article.find('[data-tag="article_description"]');
        var counter = 0;
        all_paras.each(function (index, val) {
          var new_text = $.trim($(val).text()).toLowerCase();
          if (index == all_paras.length - 1) {
            var temp_text = new_text.split('read more');
            new_text = $.trim(temp_text[0]);
            new_text = new_text.replace('...', '');
            // new_text = new_text.replace('... Read More', '');
          } else {
            new_text += ' ';
          }
          counter += new_text.length;
        });
        if (window.article_descriptions[article_id]) window.article_descriptions[article_id]['counter'] = counter;
      }
    });
}
// resizes the article image according to hero structure or small articles structure.
function image_resize(structure, articleProp) {
  try {
    var image = articleProp?.find('[data-tag="article_image"]');
    if (image.length !== 0) {
      if (structure.attr('class').indexOf('esd-structure') >= 0) {
        //This is Hero article structure
        var border = structure.closest('.es-content-body');
        var border_box = structure.closest('.es-content-body').find('[data-article] table[data-border]');
        var frame = image.closest('.esd-container-frame');
        // Calculating width w.r.t border length
        try {
          var total_border = 0;
          if (border_box.css('border-left-width').length) {
            total_border += parseInt(border_box.css('border-left-width').split('px')[0]);
          }
          if (border_box.css('border-right-width').length) {
            total_border += parseInt(border_box.css('border-right-width').split('px')[0]);
          }
          if (border.css('border-left-width').length) {
            total_border += parseInt(border.css('border-left-width').split('px')[0]);
          }
          if (border.css('border-right-width').length) {
            total_border += parseInt(border.css('border-right-width').split('px')[0]);
          }
          var width = 570 - total_border;
          frame.attr('width', '570').css('display', 'block');
        } catch (err) {
          // if something goes wrong set width to MAX
          width = 568;
        }
        var height = 312;
        if (parseInt(_template_style_id) === 3) {
          width = 600;
          height = 185;
        }
        if (parseInt(_template_style_id) === 4) {
          width = 200;
          height = 150;
        }
      } else {
        //This is small articles structure
        var width = 275;
        var height = 195;
      }

      image.attr('width', width);
      image.css('width', width);
      image.attr('height', height);
      image.css('height', height);
      var newSource = image.attr('src');
      if (!newSource) {
        let imageURL_From_redux = store.getState().design?.data?.section[0]?.articles[0]?.article_image;
        newSource = decodeURIComponent(imageURL_From_redux);
      }
      // if (newSource !== "") {
      newSource = new URL(newSource);
      newSource.searchParams.set('width', width);
      newSource.searchParams.set('height', height);
      newSource = newSource.href;
      image.attr('src', newSource);
      // }
    }
  } catch (err) {
    console.log(err);
  }
}
function init_stripo_plugin_callback(design, callback = true, skipUpdateHtml = false) {
  if (window.location.pathname.includes('design')) {
    $('#load-template').removeClass('d-none');
    if ($('#load-template').hasClass('stripo-hide')) {
      $('#load-template').removeClass('stripo-hide');
    }
    $('.hidden-stripo').remove();
  }

  var checkExist2 = setInterval(function () {
    if ($('.stripo-preview-frame').length) {
      var contents = $('.stripo-preview-frame').contents(); // contents of the iframe
      contents.find('[data-article]').each(function (index, article) {
        article = $(article);
        image_resize(article, article.find('.articleProperties'));
      });
      reset_description_counter();
      load_hero_small_structure_template(skipUpdateHtml);

      // styles needed for removing skeleton loader and displaying IFrame
      $('.full-page-height').css('overflow', 'hidden');
      $('.sk-container').addClass('d-none');
      if ($('#load-template').hasClass('stripo-hide')) {
        $('#load-template').removeClass('stripo-hide');
      }
      $('#load-template').css('height', 'inherit');
      $('.esdev-preview-splitter.full-height').css('height', 'inherit');
      $('.stripo-preview-frame').css('height', 'inherit');
      // $(".stripo-preview-frame").css("padding-bottom", "0");
      // remove styles for case when user has clicked to change templates
      $('#select-template').css('pointer-events', 'auto');
      $('#select-template').css('background-color', 'unset');
      $('#controls-btn>button.disabled').removeClass('disabled');
      clearInterval(checkExist2);
    }
  }, 500);
}

// Append style to make fancy scroll and other customization
function appendStyle(contents) {
  var styleToAppend =
    "<style id='xiq-custom-style'>html{overflow-y: auto;-webkit-overflow-scrolling:touch; \n" +
    'scrollbar-color: #001760 #efefef; scrollbar-width: thin;} body{scrollbar-width: thin;} html::-webkit-scrollbar-track {\n' +
    '-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n' +
    'box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n' +
    'background-color: #efefef;\n' +
    '} html::-webkit-scrollbar-track {\n' +
    ' -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n' +
    'box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n' +
    'background-color: #efefef;\n' +
    '} html::-webkit-scrollbar-track {\n' +
    '-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n' +
    'box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n' +
    'background-color: #efefef;\n' +
    '} html::-webkit-scrollbar {\n' +
    'width: 6px; height: 6px;\n' +
    'background-color: #efefef;\n' +
    '} html::-webkit-scrollbar-thumb {\n' +
    '-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n' +
    'box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n' +
    'background-color:  #001760;\n' +
    '} .es-wrapper .esd-email-paddings {\n' +
    'padding-top: 45px;\n' +
    '} .es-wrapper .esd-email-paddings.esd-email-paddings-increased{padding-top:45px !important;' +
    '}  .cke_panel{\n' +
    'border-radius: 5px;box-shadow: 4px 0 12px 0 rgba(60, 70, 99, 0.35);z-index: 99993 !important;}' +
    '.cke_combopanel__mergetags{max-height: 190px;} .missing-link {outline: 2px dashed red;display: inline-block;}' +
    '[data-load] td{text-align: left;}' +
    '.load-more{text-align: left; cursor: pointer; font-size: 12px; padding: 5px 0; color:#1EC052; margin:5px 10px;' +
    'display: inline-block; text-decoration: underline;background-color: transparent !important;\n' +
    'border: none !important;} img[data-tag="article_image"]{max-width: 100%;} .esd-structure > .esd-block-btn div a{padding: 12px 5px 15px;}\n' +
    '.load-more:hover, .load-more:focus, .load-more:active{\n' +
    'background-color: trsnparent;color: #1EC052 !important;}' +
    '.esd-structure > .esd-block-btn div a [class^="es-icon-"]{font-size: 10px;}\n' +
    '.esd-structure > .esd-block-btn.esd-activated{width: 120px;} .esd-container-frame.esd-frame > .esd-block-btn{display:none !important;}' +
    '.esd-block-btn .esd-save .es-icon-save:before{content:"";' +
    'background-image: url(https://media.xiq.io/user_images/1600794485_2dfc4cc2-fcf6-11ea-a642-0a723d0dce2e.svg);' +
    'height: 15px;background-size: 18px 15px;background-repeat: no-repeat;} .drag a{z-index: 99;} .articleProperties:hover .drag a{z-index: 99999;} img{-webkit-user-drag: none;} ' +
    '</style>';
  $(contents).find('head').append(styleToAppend);
  // start we can remove this code after 6 month on 1/6/2023
  var stripoStyle = '@media all and (max-width: 600px) { .drop tbody>tr>td { height: auto !important; max-height:none !important;} }';
  $(contents)
    .find('.esdev-css')
    .html($(contents).find('.esdev-css').html() + stripoStyle);
  $(contents)
    .find('.articleProperties')
    .each(function (index) {
      $(this).find("[data-tag='article_title']").closest('td').attr('data-td', 'title-td');
      $(this).find("[data-tag='article_description']").closest('td').attr('data-td', 'description-td');
    });
  // End we can remove this code after 6 month on 1/6/2023
}

function load_articles_descriptions(design) {
  if (design?.section?.length > 0) {
    design.section[0].articles.map(function (i) {
      window.article_descriptions[SECTION_ID + '-' + i.article_id] = {
        counter: i.description_counter,
        full_description: i.full_description,
      };
    });
  }
}
// To detect stripo changes, Returns true if current_HTML === window.page_HTML
function check_changes(current_HTML) {
  var hidden_div = $('<div>').attr({ type: 'hidden', id: 'foo', name: 'bar' });
  hidden_div.html(current_HTML);
  $(hidden_div).contents().find('[data-drag]').remove();
  $(hidden_div)
    .contents()
    .find('.esd-block-text')
    .each(function (index, textItem) {
      $(textItem).html($.trim($(textItem).html()));
    });
  $(hidden_div)
    .contents()
    .find('[data-article]')
    .each(function (index, article) {
      var article = $(this);
      var border = article.find('[data-border]');
      if (typeof border !== 'undefined' && border.length) {
        border.removeAttr('style');
        border.removeAttr('width');
        border.removeAttr('height');
      } else if (typeof article.data('border') !== 'undefined') {
        article.removeAttr('style');
        article.removeAttr('width');
        border.removeAttr('height');
      }
      article.find('[data-tag=article_description]').text($.trim(article.find('[data-tag=article_description]').text()));

      article.find('[data-tag=article_title]').text($.trim(article.find('[data-tag=article_title]').text()));
      article.find('[data-tag=article_domain]').text($.trim(article.find('[data-tag=article_domain]').text()));
      var props = article.find('.articleProperties');
      var src = props.find('[data-tag=article_image]').attr('src');
      src = decodeURIComponent(src);
      props.find('[data-tag=article_image]').attr('src', src);
    });
  $(hidden_div)
    .contents()
    .find('[spellcheck]')
    .each(function (index, item) {
      // $(this).removeAttr("role");
      $(this).removeAttr('spellcheck').removeAttr('role');
    });
  $(hidden_div)
    .contents()
    .find('[data-article]>tbody>tr>td, td[data-article]')
    .removeAttr('bgcolor')
    .attr('style', function (i, style) {
      return style && style.replace(/background-color[^;]+;?/g, '');
    });
  $(hidden_div).contents().find('[data-article] td').removeClass('es-m-p0l').removeClass('es-m-p0r').filter('[class=""]').removeAttr('class');
  $(hidden_div).contents().find('[spacer-row], #loadmore-style, #editor-style, #defaults, .feature-story').remove();
  $(hidden_div).contents().find('[id^=section-] table[data-article]').closest('td').css('padding-top', '0').css('padding-bottom', '0');
  var current_HTML = $(hidden_div).html();
  current_HTML = $.trim(current_HTML);

  hidden_div.html(window.page_HTML);
  $(hidden_div).contents().find('[data-drag]').remove();
  $(hidden_div)
    .contents()
    .find('.esd-block-text')
    .each(function (index, textItem) {
      $(textItem).html($.trim($(textItem).html()));
    });
  $(hidden_div)
    .contents()
    .find('[data-article]')
    .each(function (index, article) {
      var article = $(article);
      var border = article.find('[data-border]');
      if (typeof border !== 'undefined' && border.length) {
        border.removeAttr('style');
        border.removeAttr('width');
        border.removeAttr('height');
      } else if (typeof article.data('border') !== 'undefined') {
        article.removeAttr('style');
        article.removeAttr('width');
        article.removeAttr('height');
      }
      article.find('[data-tag=article_description]').text($.trim(article.find('[data-tag=article_description]').text()));

      article.find('[data-tag=article_title]').text($.trim(article.find('[data-tag=article_title]').text()));
      article.find('[data-tag=article_domain]').text($.trim(article.find('[data-tag=article_domain]').text()));
      var props = article.find('.articleProperties');
      var src = props.find('[data-tag=article_image]').attr('src');
      src = decodeURIComponent(src);
      props.find('[data-tag=article_image]').attr('src', src);
    });
  $(hidden_div)
    .contents()
    .find('[spellcheck]')
    .each(function (index, item) {
      $(this).removeAttr('spellcheck').removeAttr('role');
      // $(this).removeAttr("role");
    });
  $(hidden_div)
    .contents()
    .find('[data-article]>tbody>tr>td, td[data-article]')
    .removeAttr('bgcolor')
    .attr('style', function (i, style) {
      return style && style.replace(/background-color[^;]+;?/g, '');
    });
  $(hidden_div).contents().find('[data-article] td').removeClass('es-m-p0l').removeClass('es-m-p0r').filter('[class=""]').removeAttr('class');
  $(hidden_div).contents().find('[spacer-row], #loadmore-style, #editor-style, #defaults, .feature-story').remove();
  $(hidden_div).contents().find('[id^=section-] table[data-article]').closest('td').css('padding-top', '0').css('padding-bottom', '0');
  window.page_HTML = $(hidden_div).html();
  window.page_HTML = $.trim(window.page_HTML);
  $(hidden_div).remove();
  var check = window.page_HTML !== current_HTML;
  return check;
}

function change_template_style(template_style_id = 0, callback, enableSaveButtons) {
  try {
    var current_style = _template_style_id;
    if (current_style != template_style_id) {
      if (typeof current_style !== 'undefined') {
        current_style = parseInt(current_style);
        if (template_style_id === current_style) {
          // show_message("Choose a different template style", "warning");
          return;
        }
      }

      disablePreviewAction(); // disable preview button when changing template
      changeTemplateLoading(); // show loader when changing template

      $('.sk-container').removeClass('d-none');
      $('#load-template').addClass('d-none');
      $('.sk-container').removeClass('stripo-hidden');
      $('#load-template').addClass('stripo-hidden');
      $('#select-template').css('pointer-events', 'none');
      $('#select-template').css('background-color', '#eee');
      $(`[data-template-id='${template_style_id}']`).addClass('active');
      $(`[data-template-id='${current_style}']`).removeClass('active');
      // end of to add and remove active classes
      maintainHeight($('.stripo-preview-frame').contents());
      window.StripoApi.getTemplate(function (html_content, css, width, height) {
        window.StripoApi.compileEmail(function (error, email_html) {
          $('.static-layout-container').addClass('not_load_stripo_js');
          if (template_style_id !== current_style) {
            callback(template_style_id, 'change_template');
          }
          var modified_articles = check_modified_articles(email_html);
          var article_ids = [];
          $('.personalize_articles_stripo:checked').each(function (key, value) {
            article_ids.push(value.id.split('-')[2]);
          });
          var article_order = article_ids.join(',');

          let formData = new FormData();
          formData.append('modified_articles', modified_articles != undefined ? JSON.stringify(modified_articles) : '');
          formData.append('change_template', 1);
          formData.append('versionId', _design?.version_id ?? getQueryEmailId());
          formData.append('template_style_id', template_style_id);
          formData.append('html_content', html_content);
          formData.append('article_order', article_order);

          saveDesignHTMLService(formData, 'change_template', null, enableSaveButtons);
        });
      });
    } else {
      console.log('Same template selected.');
    }
  } catch (err) {
    console.log(err);
  }
}

//gets articles properties either from Section html or deleted_articles dictionary
function get_article_properties(id, section) {
  try {
    var newArticle = section.find('#' + id);
    // check if HTML found in section or get from deleted_articles dictionary
    if (newArticle.length) {
      newArticle = newArticle.find('.articleProperties');
    } else {
      newArticle = deleted_articles[id];
    }
    return newArticle;
  } catch (err) {
    console.log(err);
  }
}

function add_article(beforeIds, afterIds) {
  try {
    //Iterate over each section to check where article is added
    $('.stripo-preview-frame')
      .contents()
      .find('.es-content')
      .each(function (i, section) {
        var section_id = section['id'].split('-')[1];
        var section = $(section);
        var sectionArticlesNew = afterIds.filter(function (value, index, arr) {
          return value.split('-')[0] === section_id;
        });
        var sectionArticlesOld = beforeIds.filter(function (value, index, arr) {
          return value.split('-')[0] === section_id;
        });

        //check if no articles added in this section
        if (sectionArticlesNew.length === sectionArticlesOld.length) {
          return;
        }
        let temp_section = section.clone();
        //if an article is to be added at top
        if (sectionArticlesNew.length === 3 && !(parseInt(_template_style_id) === 3) && !(parseInt(_template_style_id) === 4)) {
          var last_article = section.find('[data-article]').last();
          // for multiple sections, append hero article after the section name row
          if (last_article.parent('.esd-structure').parent().parent().find('[data-section]').length > 0) {
            let section_name_el = last_article.parent('.esd-structure').parent().parent().find('[data-section]');
            hero_article_structure.clone().insertAfter(section_name_el.parent());
          } else {
            last_article.parent('.esd-structure').parent().parent().prepend(hero_article_structure.clone());
          }

          section.find('[data-article]').each(function (index, article) {
            article = $(article);
            var id = sectionArticlesNew[index];
            var newArticle = get_article_properties(id, temp_section);
            if (newArticle !== undefined) {
              image_resize(article, newArticle);
              article.find('.articleProperties').html(newArticle.html());
              article.attr('id', id);
            }
          });
          return;
        }

        //reorder all articles in given order, except the last one
        section.find('[data-article]').each(function (index, article) {
          var article = $(article);
          var id = sectionArticlesNew[index];
          var newArticle = get_article_properties(id, temp_section);
          if (newArticle !== undefined) {
            image_resize(article, newArticle);
            article.find('.articleProperties').html(newArticle.html());
            article.attr('id', id);
          }
        });
        var id = sectionArticlesNew[sectionArticlesNew.length - 1];
        var newArticle = get_article_properties(id, temp_section);
        last_article = section.find('[data-article]').last();
        if (
          last_article.length > 0 &&
          last_article.attr('class').indexOf('esd-structure') >= 0 &&
          !(_template_style_id == 3) &&
          !(_template_style_id == 4)
        ) {
          //Last article is a hero, so make last 2 articles Small
          var small_articles = small_articles_structure.clone();

          image_resize(small_articles.find('[data-article]'), last_article.find('.articleProperties'));
          var first_arr = small_articles.find('[data-article]').first();
          first_arr.find('.articleProperties').html(last_article.find('.articleProperties').html());
          first_arr.attr('id', last_article.attr('id'));

          image_resize(small_articles.find('[data-article]'), newArticle);
          var second_arr = small_articles.find('[data-article]').last();
          second_arr.find('.articleProperties').html(newArticle.html());
          second_arr.attr('id', id);
          last_article.parent().html(small_articles.html());
        } else {
          //Append a hero structure at the bottom
          var hero_article = hero_article_structure.clone();
          section.find('.es-content-body').children(':first-child').append(hero_article);

          image_resize(hero_article.find('[data-article]'), newArticle);
          hero_article.find('.articleProperties').html(newArticle.html());
          hero_article.find('.esd-structure').attr('id', id);
        }
        if (parseInt(_template_style_id) === 3) {
          template4_reorder_style($('.stripo-preview-frame').contents());
        }
        if (parseInt(_template_style_id) === 4) {
          template5_reorder_style_2($('.stripo-preview-frame').contents());
        }
      });
    dragAndDropArticle();
  } catch (err) {
    console.log(err);
  }
}

function delete_article(beforeIds, afterIds) {
  try {
    //Iterate over each section to check where article is removed
    $('.stripo-preview-frame')
      .contents()
      .find('.es-content')
      .each(function (i, section) {
        var section_id = section['id'].split('-')[1];
        var section = $(section);
        var deleted_index = -1;
        var sectionArticlesNew = afterIds.filter(function (value, index, arr) {
          return value.split('-')[0] === section_id;
        });
        var sectionArticlesOld = beforeIds.filter(function (value, index, arr) {
          return value.split('-')[0] === section_id;
        });
        // Saving deleted articles properties and id
        sectionArticlesOld.forEach(function (value, i) {
          if (!sectionArticlesNew.includes(value)) {
            deleted_index = i;
            deleted_articles[value] = section
              .find('#' + value)
              .find('.articleProperties')
              .clone();
          }
        });
        //check if no articles removed in this section
        if (deleted_index === -1) {
          return;
        }
        let temp_section = section.clone();
        var last_article = '';
        var last_structure = section.find('[data-article]').last().parent();

        if (typeof last_structure.find('.esd-structure').data('article') !== 'undefined') {
          //last article is hero, 2nd last structure is of 2 small articles
          var second_last = section.find('[data-article]').eq(-2).parent('.esd-structure').parent();
          if (deleted_index === sectionArticlesOld.length - 1) {
            //The Deleted article is last one so remove that structure
            last_structure.remove();
          } else {
            //Push all articles above and then delete last structure
            section.find('[data-article]').each(function (index, article) {
              article = $(article);
              if (index < sectionArticlesNew.length) {
                var id = sectionArticlesNew[index];
                last_article = article;
                var newArticle = get_article_properties(id, temp_section);
                image_resize(article, newArticle);
                article.find('.articleProperties').html(newArticle.html());
                article.attr('id', id);
              }
            });
            last_structure.remove();
          }
        } else {
          var last_structure = last_structure.parent();
          var second_last = section.find('[data-article]').eq(-3).parent();
          if (typeof second_last.find('.esd-structure').data('article') !== 'undefined') {
            //Second last article is hero, Last Structure is Of 2 small articles
            if (deleted_index === sectionArticlesOld.length - 1) {
              //last article is deleted, so clone 3rd last and 2nd last in last struture and remove Hero_structure
              image_resize(last_structure.find('[data-article]').first(), second_last.find('.articleProperties'));
              last_structure.find('[data-article]').first().find('.articleProperties').html(second_last.find('.articleProperties').html());
              last_structure.find('[data-article]').first().attr('id', second_last.find('.esd-structure').attr('id'));
              var second_last_article = temp_section.find('[data-article]').last().prev();
              last_structure.find('[data-article]').last().find('.articleProperties').html(second_last_article.find('.articleProperties').html());
              last_structure.find('[data-article]').last().attr('id', second_last_article.attr('id'));
              second_last.remove();
            } else if (deleted_index === sectionArticlesOld.length - 2) {
              //2nd last article is deleted, so clone above hero article in its place
              image_resize(last_structure.find('[data-article]').first(), second_last.find('.articleProperties'));
              last_structure.find('[data-article]').first().find('.articleProperties').html(second_last.find('.articleProperties').html());
              last_structure.find('[data-article]').first().attr('id', second_last.find('.esd-structure').attr('id'));
              second_last.remove();
            } else {
              //Push all articles above till 2nd last articles and delete 2nd last structure
              section.find('[data-article]').each(function (index, article) {
                article = $(article);
                if (index < sectionArticlesNew.length - 1) {
                  var id = sectionArticlesNew[index];
                  last_article = article;
                  var newArticle = get_article_properties(id, temp_section);
                  image_resize(article, newArticle);
                  article.find('.articleProperties').html(newArticle.html());
                  article.attr('id', id);
                }
              });
              second_last.remove();
            }
          } else {
            //Both last and 2nd last structures contain small articles
            var second_last = second_last.parent();
            if (deleted_index === sectionArticlesOld.length - 1) {
              var article = last_structure.find('[data-article]').last().prev();
            } else {
              section.find('[data-article]').each(function (index, article) {
                article = $(article);
                if (index < sectionArticlesNew.length - 1) {
                  var id = sectionArticlesNew[index];
                  last_article = article;
                  var newArticle = get_article_properties(id, temp_section);
                  image_resize(article, newArticle);
                  article.find('.articleProperties').html(newArticle.html());
                  article.attr('id', id);
                }
              });
              article = last_structure.find('[data-article]').last();
            }

            var article_prop = article.find('.articleProperties');
            var hero_article = hero_article_structure.clone();
            last_structure.remove();
            section.find('.es-content-body').children(':first-child').append(hero_article);
            image_resize(hero_article.find('[data-article]'), article_prop);
            hero_article.find('.articleProperties').html(article_prop.html());
            hero_article.find('.esd-structure').attr('id', article.attr('id'));
          }
        }
      });
    dragAndDropArticle();
  } catch (err) {
    console.log(err);
  }
}

function getPreview(callback) {
  // maintainHeight($(".stripo-preview-frame").contents());
  setTimeout(() => {
    window.StripoApi.getTemplate(function (html_content, css, width, height) {
      try {
        return window.StripoApi.compileEmail(function (error, email_html) {
          callback(true, html_content, email_html);
        });
      } catch (e) {
        $('.loader').hide();
        console.error(e);
      }
    });
  }, 500);
}

function getContentforSave(
  current_template_id,
  url,
  history,
  callback,
  saveAsEmail,
  asset_name,
  campaign_name,
  campaign_id,
  handleCancel,
  showMessage,
  setToggleDisabled,
  saveAsTemplate,
  regeneration,
  changeAIEmail,
  eventType,
) {
  $('#load-template iframe').contents().find('a').removeClass('missing-link');
  if (
    // .is(":visible")
    $('#load-template iframe')
      .contents()
      .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
      .find(
        'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
      ).length > 0
  ) {
    $('#load-template iframe')
      .contents()
      .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
      .find(
        'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
      )
      // .is(":visible")
      .addClass('missing-link');
  }

  window.StripoApi.getTemplate(function (html_content, css) {
    try {
      return window.StripoApi.compileEmail(function (error, email_html) {
        var data = {
          template_style_id: _template_style_id ? _template_style_id : '0',
          // text email will always update:
          // case 1: save as new from digest level
          // case 2: save as new from version level
          // case 3: save and overwrite from digest level
          // case 4: save and overwrite from version level
          update_text_email: 1,
          versionId: getQueryEmailId(),
          current_template_id: current_template_id ?? '0',
        };
        var modified_articles = check_modified_articles(email_html, saveAsEmail);
        var article_ids = [];
        $('.personalize_articles_stripo:checked').each(function (key, value) {
          article_ids.push(value.id.split('-')[2]);
        });
        var article_order = article_ids.join(',');
        if (check_changes(html_content) || saveAsEmail) {
          $.extend(data, {
            html_content: html_content,
            css_content: css,
            email_html: processEmailHTML(email_html),
            modified_articles: modified_articles != undefined ? JSON.stringify(modified_articles) : '',
            save_html: 1,
            article_order: article_order,
            asset_name: asset_name,
            campaign_name: campaign_name,
            campaign_id: campaign_id,
            asset_id: getQueryCampaignId(),
            save_as_email: saveAsEmail,
            saveAsTemplate: saveAsTemplate,
            eventType: eventType,
          });
          if (!regeneration) {
            saveAsTemplate ? setSaveLoading('Saving template') : setSaveLoading('Saving changes');
          }
          saveDesignHTMLService(
            formatSaveData(data),
            url,
            history,
            callback,
            saveAsEmail,
            handleCancel,
            showMessage,
            setToggleDisabled,
            saveAsTemplate,
            regeneration,
            changeAIEmail,
          );
        } else if (url !== undefined && url !== '') {
          history.push(url);
        }
      });
    } catch (e) {
      $('.loader').hide();
      console.error(e);
    }
  });
}
function getEmailContent(callback) {
  setTimeout(() => {
    maintainHeight($('.stripo-preview-frame').contents());
    window.StripoApi.getTemplate(function (html_content, css, width, height) {
      try {
        return window.StripoApi.compileEmail(function (error, email_html) {
          callback(html_content, processEmailHTML(email_html), css, _design?.campaign_id, _design?.version_id);
        });
      } catch (e) {
        $('.loader').hide();
        console.error(e);
      }
    });
  }, 500);
}

function checkHTMLchanges(
  callback,
  templateStyleId,
  url,
  history,
  errorMessage,
  savePublishComplete,
  saveAsEmail,
  asset_name,
  campaign_name,
  campaign_id,
) {
  if (window.StripoApi != undefined) {
    // window.StripoApi.getTemplate(function (html_content, css) {
    //   try {
    window.StripoApi.compileEmail(function (error, current_HTML) {
      $('#load-template iframe').contents().find('a').removeClass('missing-link');

      // based on template style id 3, for i2c we need to check links in a different manner
      if (templateStyleId == 3) {
        if (
          $('#load-template iframe')
            .contents()
            .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
            .find(
              'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
            )
            .is(':visible').length > 0
        ) {
          $('#load-template iframe')
            .contents()
            .find('[data-article]:visible')
            .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
            .find(
              'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
            )
            .is(':visible')
            .addClass('missing-link');
        }
        // for normal links we are check if the missing a[href] > 2, because there are always 2 missing links found in this template due to the top article difference.
        if (
          $('#load-template iframe')
            .contents()
            .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
            .find(
              'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
            ).length > 2
        ) {
          $('#load-template iframe')
            .contents()
            .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
            .find(
              'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
            )
            .addClass('missing-link');
        }
        $('#load-template iframe')
          .contents()
          .find('.esd-block-text a')
          .each(function () {
            if ($(this).parent('[class^="esd-"]').length < 1) {
              var attrLink = $(this).attr('href');
              if (!(typeof attrLink !== typeof undefined && attrLink !== false)) {
                $(this).addClass('missing-link');
              }
            }
          });

        // check if the email has 'Unsubscribe' link otherwise show error message
        if ($('#load-template iframe').contents().find('a[href="*|unSubscribeLink|*"]').length < 1 && url.includes('publish')) {
          errorMessage('There is missing unsubscribe link in this email. Please add unsubscribe link.');
          // set missing link error in reducer
          setMissingLinkErrorOnDesign(true);
          savePublishComplete(false);

          setTimeout(() => {
            setMissingLinkErrorOnDesign(false);
          }, 100);
          return;
        }
        if ($('#load-template iframe').contents().find('a.missing-link').length > 2 && url.includes('publish')) {
          errorMessage('There are missing link(s) in this asset. Add link or remove the CTAs.');
          // set missing link error in reducer`
          setMissingLinkErrorOnDesign(true);
          savePublishComplete(false);

          setTimeout(() => {
            setMissingLinkErrorOnDesign(false);
          }, 100);

          return;
        }
      } else {
        if (
          // .is(":visible")
          $('#load-template iframe')
            .contents()
            .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
            .find(
              'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
            ).length > 0
        ) {
          $('#load-template iframe')
            .contents()
            .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
            .find(
              'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
            )
            // .is(":visible")
            .addClass('missing-link');
        }

        $('#load-template iframe')
          .contents()
          .find('.esd-block-text a')
          .each(function () {
            if ($(this).parent('[class^="esd-"]').length < 1) {
              var attrLink = $(this).attr('href');
              if (!(typeof attrLink !== typeof undefined && attrLink !== false)) {
                $(this).addClass('missing-link');
              }
            }
          });

        // check if the email has 'Unsubscribe' link otherwise show error message
        if ($('#load-template iframe').contents().find('a[href="*|unSubscribeLink|*"]').length < 1 && url.includes('publish')) {
          errorMessage('There is missing unsubscribe link in this email. Please add unsubscribe link.');
          // set missing link error in reducer
          setMissingLinkErrorOnDesign(true);
          savePublishComplete(false);

          setTimeout(() => {
            setMissingLinkErrorOnDesign(false);
          }, 100);
          return;
        }

        if ($('#load-template iframe').contents().find('a.missing-link').length > 1 && templateStyleId == 4 && url.includes('publish')) {
          errorMessage('There are missing link(s) in this asset. Add link or remove the CTAs.');
          // set missing link error in reducer
          setMissingLinkErrorOnDesign(true);
          savePublishComplete(false);

          setTimeout(() => {
            setMissingLinkErrorOnDesign(false);
          }, 100);

          return;
        }

        if ($('#load-template iframe').contents().find('a.missing-link').length > 0 && templateStyleId != 4 && url.includes('publish')) {
          errorMessage('There are missing link(s) in this asset. Add link or remove the CTAs.');
          // set missing link error in reducer
          setMissingLinkErrorOnDesign(true);
          savePublishComplete(false);

          setTimeout(() => {
            setMissingLinkErrorOnDesign(false);
          }, 100);

          return;
        }
      }
      if (check_changes(current_HTML) || url?.includes('publish')) {
        if (callback) callback(templateStyleId, url, history, savePublishComplete, saveAsEmail, asset_name, campaign_name, campaign_id);
      } else {
        store.dispatch({ type: SAVING_DESIGN.RESET });
        if (url) history.push(url);
      }
    });
  }
}

function checkMissingLinkAfterSaving(callback, errorMessage, savePublishComplete) {
  if (window.StripoApi != undefined) {
    window.StripoApi.compileEmail(function (error, current_HTML) {
      if ($('#load-template iframe').contents().find('a.missing-link').length > 0) {
        errorMessage('There are missing link(s) in this asset. Add link or remove the CTAs.');
        // set missing link error in reducer
        setMissingLinkErrorOnDesign(true);
        savePublishComplete(false);

        setTimeout(() => {
          setMissingLinkErrorOnDesign(false);
        }, 100);

        return;
      } else {
        callback();
      }
    });
  }
}

function checkAIEmailHTMLchanges(callback, callback2, callback3, isEmailChange, templateStyleId, designData, errorMessage, savePublishComplete) {
  if (window.StripoApi != undefined) {
    window.StripoApi.compileEmail(function (error, current_HTML) {
      if (check_changes(current_HTML)) {
        if (isEmailChange) {
          getContentforSave(templateStyleId, null, null, null, null, null, null, null, null, null, null, null, null, () =>
            checkMissingLinkAfterSaving(callback3, errorMessage, savePublishComplete),
          );
        } else {
          callback(true);
        }
      } else {
        if (!isEmailChange) {
          callback2(true);
        } else {
          if (designData) setAIEmailDesign(getQueryEmailId().toString(), designData);
          checkMissingLinkAfterSaving(callback3, errorMessage, savePublishComplete);
        }
      }
    });
  }
}

function autoSaveDesignChanges(callback, templateStyleId) {
  if (window.StripoApi != undefined) {
    window.StripoApi.getTemplate(function (html_content, css) {
      if (check_changes(html_content)) {
        if (callback) callback(templateStyleId, null, null, null, null, null, null, null, null, true);
      }
    });
  }
}

let staticEmail = store.getState().design.data.asset_type === 'custom';
if (!staticEmail) {
  $(document).on('change', '.personalize_articles_stripo', function (event) {
    try {
      var $this = $(this);
      var afterIds = [];
      $('.personalize_articles_stripo:checked').each(function (key, value) {
        afterIds.push(value.id.split('article-')[1]);
      });
      if (afterIds.length === 0) disablePublishButton();
      else enablePublishButton();
      
      if ($this.prop('checked') == false) {
        // $(".per-right-articles ").find("#" + section_id + "-" + article_id).remove();
        delete_article(window.right_article_array, afterIds);
        $(this).closest('.plus-icon-wrapper').removeClass('added');
        $(this).prop('checked', false);
      } else {
        add_article(window.right_article_array, afterIds);
        $(this).closest('.plus-icon-wrapper').addClass('added');
        $(this).prop('checked', true);
      }
      if (parseInt(_template_style_id) === 2) {
        template3_reorder_style($('.stripo-preview-frame').contents());
      }
      if (parseInt(_template_style_id) === 3) {
        template4_reorder_style($('.stripo-preview-frame').contents());
      }
      if (parseInt(_template_style_id) === 4) {
        template5_reorder_style_2($('.stripo-preview-frame').contents());
      }
      window.right_article_array = afterIds;
    } catch (err) {
      console.log(err);
    }
  });

  //synchronize Sidebar Article image and title on undo and redo
  $('#undoButton, #redoButton').on('click', function () {
    setTimeout(function () {
      var contents = $('.stripo-preview-frame').contents();
      $(contents)
        .find("img[data-tag='article_image']")
        .each(function (index) {
          var url = new URL($(this).attr('src'));
          url.searchParams.set('width', '150');
          url.searchParams.set('height', '150');
          $('.per-right-articles .sidebar-article#' + $(this).closest('[data-article]').attr('id') + ' .img-wrap img').attr('src', url.href);
        });
      $(contents)
        .find("[data-tag='article_title']")
        .each(function (index) {
          $('.per-right-articles .sidebar-article#' + $(this).closest('[data-article]').attr('id') + ' .right-side .title').text(
            $(this).closest('.esd-block-text').find("[data-tag='article_title']").text(),
          );
        });
      $(contents).find('body').css('opacity', '1'); // when undo/redo opacity will be set to 1
      maintainHeight(contents);
      $(contents)
        .contents()
        .find('[data-drag] td')
        .html(
          '<span class="drag ui-draggable ui-draggable-handle" style="position: relative; top: 0px; left: 0px;">\n' +
            '<a class="esd-frame-element esd-hover-element esdev-disable-select">\n' +
            '<img src="https://media.xiq.io/user_images/1600794455_1c4c2182-fcf6-11ea-8308-0a723d0dce2e.svg" style="display: inline; width: 15px; height: 14px; border-width: 0px;" class="esd-frame-element esd-hover-element esdev-disable-select" alt="">\n' +
            '</a></span>',
        );
      dragAndDropArticle();
    }, 1500);
    // call maintain order and state of article on undo / redo
    setTimeout(function () {
      dragAndDropArticle();
      bindImagesWithTemplate();
      matchArticleOrder();
      reset_description_counter();
    }, 500);
  });
}

function formatSaveData(data) {
  let formData = new FormData();
  if (data.saveAsTemplate) {
    formData.append('save_as_template', data.saveAsTemplate ? 1 : 0);
    formData.append('version_name', data.asset_name);
    formData.append('html_content', data.html_content);
    formData.append('css_content', data.css_content);
    formData.append('versionId', data.versionId);
    formData.append('email_html', data.email_html);
  } else {
    formData.append('html_content', data.html_content);
    formData.append('css_content', data.css_content);
    formData.append('email_html', data.email_html);
    formData.append('modified_articles', data.modified_articles);
    formData.append('save_html', data.save_html);
    formData.append('article_order', data.article_order);
    formData.append('template_style_id', data.template_style_id);
    formData.append('update_text_email', data.update_text_email);
    formData.append('versionId', data.versionId);
    formData.append('current_template_id', data.current_template_id);
    if (data.save_as_email) {
      formData.append('save_as_email', data.save_as_email);
      formData.append('asset_id', data.asset_id);
      formData.append('asset_name', data.campaign_name);
      formData.append('version_name', data.asset_name);
      formData.append('campaign_id', data.campaign_id);
      if (data.eventType) formData.append('event_type', data.eventType);
    }
    // formData.append("asset_id", data.asset_id);
    // formData.append("asset_name", data.asset_name);
    // formData.append("version_name", data.version_name);
    // formData.append("campaign_id", data.campaign_id);
  }
  return formData;
}

function checkForUnsubLink(templateStyleId, errorMessage, savePublishComplete, html, url, asset_name, campaign_name, campaign_id) {
  if (window.StripoApi != undefined) {
    // window.StripoApi.compileEmail(function (error, current_HTML, css) {
    $('#load-template iframe').contents().find('a').removeClass('missing-link');

    // based on template style id 3, for i2c we need to check links in a different manner
    if (templateStyleId == 3) {
      if (
        $('#load-template iframe')
          .contents()
          .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
          .find(
            'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
          )
          .is(':visible').length > 0
      ) {
        $('#load-template iframe')
          .contents()
          .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
          .find(
            'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
          )
          .is(':visible')
          .addClass('missing-link');
      }

      // for normal links we are check if the missing a[href] > 2, because there are always 2 missing links found in this template due to the top article difference.
      if (
        // .is(":visible")
        $('#load-template iframe')
          .contents()
          .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
          .find(
            'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
          ).length > 2
      ) {
        $('#load-template iframe')
          .contents()
          .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
          .find(
            'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
          )
          .is(':visible')
          .addClass('missing-link');
      }

      // $("#load-template iframe")
      //   .contents()
      //   .find(".esd-block-text a")
      //   .each(function () {
      //     if ($(this).parent('[class^="esd-"]').length < 1) {
      //       var attrLink = $(this).attr("href");
      //       if (!(typeof attrLink !== typeof undefined && attrLink !== false)) {
      //         $(this).addClass("missing-link");
      //       }
      //     }
      //   });

      // check if the email has 'Unsubscribe' link otherwise show error message
      if ($('#load-template iframe').contents().find('a[href="*|unSubscribeLink|*"]').length < 1) {
        errorMessage('2. There is missing unsubscribe link in this email. Please add unsubscribe link.');
        // set missing link error in reducer
        setMissingLinkErrorOnDesign(true);

        setTimeout(() => {
          setMissingLinkErrorOnDesign(false);
        }, 100);
        return false;
      }

      if ($('#load-template iframe').contents().find('a.missing-link').length > 0) {
        errorMessage('2. There are missing link(s) in this asset. Add link or remove the CTAs.');

        // set missing link error in reducer
        setMissingLinkErrorOnDesign(true);

        setTimeout(() => {
          setMissingLinkErrorOnDesign(false);
        }, 100);

        return false;
      }
    } else {
      if (
        // .is(":visible")
        $('#load-template iframe')
          .contents()
          .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
          .find(
            'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
          ).length > 0
      ) {
        $('#load-template iframe')
          .contents()
          .find('.esd-block-button, .esd-block-social, .esd-block-html, .esd-block-text')
          .find(
            'a[href="https://#"], a[href=""], a[href="#"], a[href="https://"], a[href="mailto:"], a[href="ftp://"], a[href="skype:"], a[href="tel:"], a[href="sms:"]',
          )
          // .is(":visible")
          .addClass('missing-link');
      }

      $('#load-template iframe')
        .contents()
        .find('.esd-block-text a')
        .each(function () {
          if ($(this).parent('[class^="esd-"]').length < 1) {
            var attrLink = $(this).attr('href');
            if (!(typeof attrLink !== typeof undefined && attrLink !== false)) {
              $(this).addClass('missing-link');
            }
          }
        });

      // check if the email has 'Unsubscribe' link otherwise show error message
      if ($('#load-template iframe').contents().find('a[href="*|unSubscribeLink|*"]').length < 1) {
        errorMessage('There is missing unsubscribe link in this email. Please add unsubscribe link.');
        // set missing link error in reducer
        setMissingLinkErrorOnDesign(true);

        setTimeout(() => {
          setMissingLinkErrorOnDesign(false);
        }, 100);
        return false;
      }

      if ($('#load-template iframe').contents().find('a.missing-link').length > 0) {
        errorMessage('There are missing link(s) in this asset. Add link or remove the CTAs.');

        // set missing link error in reducer
        setMissingLinkErrorOnDesign(true);

        setTimeout(() => {
          setMissingLinkErrorOnDesign(false);
        }, 100);

        return false;
      }
    }
    return true;
    // });
  } else {
    errorMessage('Stripo is not initialized.');
  }
}

export {
  init_stripo_plugin,
  init_stripo_plugin_callback,
  change_template_style,
  load_stripo,
  check_changes,
  checkHTMLchanges,
  rerender_after_save,
  getContentforSave,
  getEmailContent,
  maintainHeight,
  getPreview,
  showLoader,
  setTemplate,
  checkForUnsubLink,
  checkAIEmailHTMLchanges,
  // autoSaveDesignChanges,
  // init_after_auto_save,
  // autoSaveAPICall,
};

$(function () {
  $('.per-right-articles').sortable();
  $('.per-right-articles').disableSelection();
});
